export default __webpack_public_path__ + "static/0177-ba1c52fe4c2996ff6f84fbab6302a81b.png";